import { ValidCouponCodes } from 'store/signup/signup.types';

import {
  BLUE_LINE_ONBOARDING_PRICE_POINTS,
  SEMAGLUTIDE_PRICE_POINT,
  TIRZEPATIDE_PRICE_POINT,
  WM_INSURANCE_ALT_VALID_PRICE_POINTS
} from 'constants/pricepoints';
import { FlowTypes } from 'utils/enums';
import { parseDecimal } from 'utils/helpers';

import { PricePoint } from 'models/plans.types';

import { PaymentCardDataProps } from './checkout.types';

export const getDataForPayment = (
  pp: PricePoint,
  couponCode?: ValidCouponCodes | '',
  flow?: FlowTypes
): PaymentCardDataProps => {
  const returnData: PaymentCardDataProps = {
    discountAmount: '',
    discountPercentage: '',
    ppPrice: pp.totalCost,
    ppSubheader: '',
    ppTitle: ''
  };
  const isCompoundMedication = [SEMAGLUTIDE_PRICE_POINT, TIRZEPATIDE_PRICE_POINT].includes(
    pp.planPricePointId
  );
  if (flow === FlowTypes.WeightManagementBalladHealth) {
    switch (pp.paymentInterval.qty) {
      case 1:
        returnData.ppTitle = `1 Month GLP-1 Program`;
        returnData.ppPrice = `${Number(pp.totalCost)}`;
        returnData.ppSubheader = `Save $${Number(pp.totalCost) - 59}`;
        returnData.discountAmount = '59.00';
        break;
      case 3:
        returnData.ppTitle = '3 Month GLP-1 Program';
        returnData.ppSubheader = `Save $${Number(pp.totalCost) - 222}`;
        returnData.discountAmount = '222.00';

        break;
      default:
        break;
    }
    return returnData;
  }
  const isBlueLinePP = BLUE_LINE_ONBOARDING_PRICE_POINTS.includes(pp.planPricePointId);
  if (isBlueLinePP) {
    returnData.ppTitle = '1 Month GLP-1 Program';
    returnData.ppSubheader = 'Thin Blue Line Benefits Rx Program';
    // returnData.ppPrice = '149.00';
    // returnData.discountAmount = '90.00';
    return returnData;
  }

  if (isCompoundMedication) {
    returnData.ppTitle = `GLP-1 Weight Management (${
      pp.planPricePointId === SEMAGLUTIDE_PRICE_POINT ? 'Semaglutide' : 'Tirzepatide'
    } included)`;
    returnData.ppPrice = `${Number(pp.totalCost)}`;
    returnData.ppSubheader = `Renews at $${pp.monthlyPrice}/mo`;
    returnData.discountAmount = '100.00';
    return returnData;
  }
  if (flow === FlowTypes.WeightManagementFlowInsuranceDiscovery) {
    if (WM_INSURANCE_ALT_VALID_PRICE_POINTS.includes(pp.planPricePointId)) {
      returnData.ppTitle = `1 month membership`;
      returnData.ppPrice = pp.totalCost;
      returnData.ppSubheader = `Renews at $${pp.totalCost}/mo`;
      return returnData;
    }
    switch (pp.paymentInterval.qty) {
      case 1:
        returnData.ppTitle = `1 Month GLP-1 Program`;
        returnData.ppPrice = `${Number(pp.totalCost)}`;
        returnData.ppSubheader = `Renews at $${pp.totalCost}/mo`;
        returnData.discountAmount = '74.00';
        break;
      case 3:
        returnData.ppTitle = '3 Month GLP-1 Program';
        returnData.ppSubheader = `Renews at $${Number(pp.totalCost) - 112}`;
        returnData.discountAmount = '112';
        break;
      default:
        break;
    }
    return returnData;
  }
  switch (pp.paymentInterval.qty) {
    case 1:
      if (WM_INSURANCE_ALT_VALID_PRICE_POINTS.includes(pp.planPricePointId)) {
        returnData.ppTitle = '1 month membership';
        returnData.ppSubheader = `Renews at $${pp.monthlyPrice}/mo`;
        returnData.ppPrice = 'Free';
      } else {
        returnData.ppTitle = '1 Month GLP-1 Program';
        returnData.ppSubheader = 'Billed monthly';
      }
      break;
    case 3:
      returnData.ppTitle = '3 Month GLP-1 Program';
      returnData.ppSubheader = `Save $${parseDecimal((Number(pp.totalCost) * parseFloat('15%')) / 100)}`;
      break;
    case 6:
      returnData.ppTitle = `${pp.paymentInterval.qty} Month GLP-1 Program`;
      returnData.ppSubheader = `Save $${parseDecimal((Number(pp.totalCost) * parseFloat('25%')) / 100)}`;
      break;
    case 12:
      returnData.ppTitle = `${pp.paymentInterval.qty} Month GLP-1 Program`;
      returnData.ppSubheader = `Save $${parseDecimal((Number(pp.totalCost) * parseFloat('50%')) / 100)}`;
      break;
    default:
      break;
  }
  switch (couponCode) {
    case 'LFMD30OFF':
      returnData.ppTitle = 'Triple Therapy Program';
      returnData.discountAmount = '30.00';
      break;
    case 'GLP250OFF':
      returnData.discountPercentage = '25%';
      break;
    case 'GLP150OFF':
      returnData.discountPercentage = '50%';
      break;
    case 'GLP115REC':
      returnData.discountPercentage = '15%';
      break;
    case 'GLP125REC':
      returnData.discountPercentage = '25%';
      break;
    case 'GLP133REC':
      returnData.discountPercentage = '33%';
      break;
    case 'GLP137REC':
      returnData.discountPercentage = '37%';
      break;
    case 'GLP150REC':
      returnData.discountPercentage = '50%';
      break;
    default:
      break;
  }

  switch (returnData.discountPercentage) {
    case '15%':
      returnData.discountAmount = `${(Number(pp.totalCost) * 0.15).toFixed(2)}`;
      break;
    case '25%':
      returnData.discountAmount = `${(Number(pp.totalCost) * 0.25).toFixed(2)}`;
      break;
    case '33%':
      returnData.discountAmount = `${(Number(pp.totalCost) * 0.33).toFixed(2)}`;
      break;
    case '37%':
      returnData.discountAmount = `${(Number(pp.totalCost) * 0.37).toFixed(2)}`;
      break;
    case '50%':
      returnData.discountAmount = `${(Number(pp.totalCost) * 0.5).toFixed(2)}`;
      break;

    default:
      break;
  }
  return returnData;
};
